import { VALID_STATES, OMIT_STATES } from './utils';
export var extractState = function extractState(jsonLd) {
  var state = jsonLd['atlassian:state'];
  if (state) {
    if (typeof state === 'string') {
      var linkState = state.toLowerCase();
      if (!OMIT_STATES.includes(linkState)) {
        return {
          text: linkState,
          appearance: VALID_STATES[linkState] || 'default'
        };
      }
    } else if (state['@type'] === 'Link') {
      if (state.name) {
        return {
          text: state.name,
          appearance: state.appearance || 'default'
        };
      }
    } else if (state['@type'] === 'Object') {
      if (state.name) {
        return {
          text: state.name,
          appearance: state.appearance || 'default'
        };
      }
    }
  }
};